interface PhaseSummaryCardProps {
  phase: string;
  status: "Complete" | "In Progress" | "Finalized";
  summary: string;
  outcome: string;
}

const STATUS_STYLES: Record<string, string> = {
  Complete: "bg-green-100 text-green-700",
  "In Progress": "bg-blue-100 text-blue-700",
  Finalized: "bg-green-100 text-green-700",
};

export function PhaseSummaryCard({
  phase,
  status,
  summary,
  outcome,
}: PhaseSummaryCardProps) {
  return (
    <div className="rounded-lg border border-blue-200 bg-gradient-to-br from-blue-50 to-green-50 px-5 py-4">
      <div className="mb-1.5 flex items-center gap-2">
        <span className="text-[10px] font-bold uppercase tracking-[0.1em] text-blue-600">
          {phase}
        </span>
        <span
          className={`rounded-full px-2 py-0.5 text-[10px] font-medium ${STATUS_STYLES[status] ?? "bg-surface-alt text-secondary-foreground"}`}
        >
          {status}
        </span>
      </div>
      <p className="text-[13px] leading-relaxed text-secondary-foreground">
        {summary}
      </p>
      <p className="mt-1.5 text-[11px] text-muted-foreground">{outcome}</p>
    </div>
  );
}
